import { render } from "./CadastroTipoUsuarioView.vue?vue&type=template&id=ebde3c12"
import script from "./CadastroTipoUsuarioView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoUsuarioView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Induscapas\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__